import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import PlayButton from './playButton.png';
import styles from './index.module.scss';
import { debounce } from 'lodash';
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import './video.scss';
import classNames from 'classnames';
const VideoPlayer = (props, ref) => {
    const { videoUrl, posterImgUrl, isNeedAutoPlayHiddenBtn, className } = props;
    const $video = useRef(null);
    const [playBtnVisible, setPlayBtnVisible] = useState(typeof isNeedAutoPlayHiddenBtn === 'boolean' ? !isNeedAutoPlayHiddenBtn : true);
    const [videoPlayer, setVideoPlayer] = useState(null);
    const [isPlay, setIsPlay] = useState(false);
    const delayPlay = () => {
        if (isPlay)
            return;
        const playPromise = videoPlayer.play();
        if (!playPromise)
            return;
        playPromise
            .then(() => {
            setIsPlay(true);
        })
            .catch(e => {
            setIsPlay(false);
            console.log(e);
        });
    };
    const initVideoPlayer = () => {
        if (!videoUrl || !$video || !$video.current)
            return;
        if ($video && videoPlayer) {
            videoPlayer.src({ src: videoUrl, type: 'video/mp4' });
            return;
        }
        const videoPalyerInstance = videojs($video.current, {
            controls: false,
            autoplay: true,
            loop: true,
            preload: 'auto',
            fluid: true,
            poster: posterImgUrl,
        });
        videoPalyerInstance.on('play', () => {
            setPlayBtnVisible(false);
        });
        videoPalyerInstance.on('pause', () => {
            setPlayBtnVisible(true);
        });
        setVideoPlayer(videoPalyerInstance);
    };
    useEffect(() => {
        if (videoPlayer) {
            videoPlayer.poster(posterImgUrl);
            videoPlayer.src({ type: 'video/mp4', src: videoUrl });
            return;
        }
        initVideoPlayer();
    }, [videoUrl, $video, posterImgUrl]);
    const playVideo = () => {
        if (!videoPlayer) {
            console.log('videoplayer not initialized');
            return;
        }
        delayPlay();
    };
    const pauseVideo = () => {
        if (!videoPlayer) {
            console.log('videoplayer not initialized');
            return;
        }
        videoPlayer.pause();
        setIsPlay(false);
    };
    const toggleVideo = useCallback(debounce(() => {
        if (!videoPlayer)
            return;
        if (videoPlayer.paused()) {
            delayPlay();
        }
        else {
            videoPlayer.pause();
        }
    }, 150), [videoPlayer]);
    useImperativeHandle(ref, () => ({
        play() {
            playVideo();
        },
        pause() {
            pauseVideo();
        },
    }));
    return (React.createElement("div", { className: classNames([styles['videoContainer'], className]), onClick: toggleVideo },
        videoUrl ? (React.createElement("video", { preload: "auto", "x-webkit-airplay": "true", "webkit-airplay": "allow", "webkit-playsinline": "true", playsInline: true, ref: $video, className: "video-js", "x5-video-player-type": "h5" },
            React.createElement("source", { src: videoUrl, type: "video/mp4" }))) : null,
        playBtnVisible ? React.createElement("img", { className: styles.play, src: PlayButton, alt: "alt" }) : null));
};
export default forwardRef(VideoPlayer);
